import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Container, Row, Col, Form, Spinner } from "react-bootstrap";
import logo from "../../logo.png";
import "../login.css";
import { IoBasket, IoBus, IoCheckmarkDoneCircle } from "react-icons/io5";

const TraceabilityResult = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const result = location.state?.result?.InformasiOrder || null;
  const error = location.state?.error || null;

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" variant="primary" />
        <p>Memuat data...</p>
      </div>
    );
  }

  if (!result) {
    return <p className="text-center">Data tidak ditemukan.</p>;
  }

  const transLgs = result.data_transaksilgs?.[0] || {};
  const transPbks = result.data_transaksipbks?.[0] || {};
  const transPrs = result.data_transaksiprs?.[0] || {};
  const limbahPetani = result.limbah_petanis?.[0] || {};
  const lahanInfo = result.LahanInfo || {};

  const maxLength = limbahPetani
    ? Math.max(
        limbahPetani.catatanLimbahBatang?.length || 0,
        limbahPetani.catatanLimbahDaun?.length || 0,
        limbahPetani.catatanLimbahAkar?.length || 0
      )
    : 0;
  return (
    <div className="content">
      <header className="bg-light py-3 shadow-sm header-well">
        <Container>
          <Row className="align-items-center">
            <Col xs={12} md={6} className="d-flex align-items-center">
              <img src={logo} alt="Logo" width={40} height={45} className="me-2" />
              <strong className="fs-2">Cassava Super</strong>
            </Col>
          </Row>
        </Container>
      </header>

      <Container className="mt-4">
        <h2 className="mb-3">
          <strong>Traceability : {result.uuid}</strong>
        </h2>
        <Row className="mb-4 text-center">
          <Col md={4} className="border-end">
            <h3>
              <IoBasket />
            </h3>
            <h5 className="fw-bold">Panen</h5>
            <p>{result.tanggalPemanenan}</p>
          </Col>
          <Col md={4} className="border-end">
            <h3>
              <IoBus />
            </h3>
            <h5 className="fw-bold">Pengiriman</h5>
            <p>{transLgs.tanggalPengiriman || "Data belum tersedia"}</p>
            <p>{transLgs.waktuPengiriman || "Data belum tersedia"}</p>
            <p>
              Estimasi Tiba:{" "}
              {transLgs.estimasiWaktuTiba || "Data belum tersedia"}
            </p>
          </Col>
          <Col md={4}>
            <h3>
              <IoCheckmarkDoneCircle />
            </h3>
            <h5 className="fw-bold">Diterima</h5>
            <p>{transLgs.aktualWaktuTiba || "Data belum tersedia"}</p>
            <p>{transLgs.catatanEfisiensiRute}</p>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <h5 className="fw-bold">Order Selesai</h5>
            <p>{transPrs.tanggalselesai || "Data belum tersedia"}</p>
          </Col>
          <Col md={6}>
            <h5 className="fw-bold">Tanggal Penerimaan</h5>
            <p>{transPbks.tanggalPenerimaan || "Data belum tersedia"}</p>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>ID Lahan</Form.Label>
              <Form.Control
                readOnly
                value={result.idLahan || "Data belum tersedia"}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Estimasi Berat (kg)</Form.Label>
              <Form.Control
                readOnly
                value={result.estimasiBerat || "Data belum tersedia"}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Estimasi Harga (Rp)</Form.Label>
              <Form.Control
                readOnly
                value={result.estimasiHarga || "Data belum tersedia"}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Nama Petani</Form.Label>
              <Form.Control
                readOnly
                value={result.user.name || "Data belum tersedia"}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Email Petani</Form.Label>
              <Form.Control
                readOnly
                value={result.user.email || "Data belum tersedia"}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Kondisi Pengiriman</Form.Label>
              <Form.Control
                readOnly
                value={transLgs.kondisiPengiriman || "Data belum tersedia"}
              />
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Varietas Singkong</Form.Label>
              <Form.Control
                readOnly
                value={result.varietasSingkong || "Data belum tersedia"}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Berat Aktual (kg)</Form.Label>
              <Form.Control
                readOnly
                value={transPbks.beratTotalDiterima || "Data belum tersedia"}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Harga Aktual (Rp)</Form.Label>
              <Form.Control
                readOnly
                value={
                  transPrs.hargaaktual?.toLocaleString("id-ID") ||
                  "Data belum tersedia"
                }
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Nama Perusahaan</Form.Label>
              <Form.Control
                readOnly
                value={result.namaPerusahaan || "Data belum tersedia"}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Email Perusahaan</Form.Label>
              <Form.Control
                readOnly
                value={result.emailPerusahaan || "Data belum tersedia"}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Catatan dari Penerima</Form.Label>
              <Form.Control
                readOnly
                value={transLgs.catatanDariPenerima || "Data belum tersedia"}
              />
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Evaluasi Kualitas</Form.Label>
              <Form.Control
                readOnly
                value={transPbks.evaluasiKualitas || "Data belum tersedia"}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Catatan Kualitas</Form.Label>
              <Form.Control
                readOnly
                value={transPbks.catatanKualitas || "Data belum tersedia"}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Catatan Harga</Form.Label>
              <Form.Control
                readOnly
                value={transPrs.catatanharga || "Data belum tersedia"}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Nama Logistik</Form.Label>
              <Form.Control
                readOnly
                value={result.namaLogistik || "Data belum tersedia"}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Email Logistik</Form.Label>
              <Form.Control
                readOnly
                value={result.emailLogistik || "Data belum tersedia"}
              />
            </Form.Group>
          </Col>
        </Row>

        {result.limbah_petanis?.length > 0 && (
          <Row>
            <h5 className="fw-bold">Data Limbah</h5>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Limbah Batang (kg)</Form.Label>
                <Form.Control
                  readOnly
                  value={
                    limbahPetani.beratLimbahBatang || "Data belum tersedia"
                  }
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Limbah Daun (kg)</Form.Label>
                <Form.Control
                  readOnly
                  value={limbahPetani.beratLimbahDaun || "Data belum tersedia"}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Limbah Akar (kg)</Form.Label>
                <Form.Control
                  readOnly
                  value={limbahPetani.beratLimbahAkar || "Data belum tersedia"}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Catatan Limbah Batang</Form.Label>
                <Form.Control
                  readOnly
                  as="textarea"
                  style={{ height: `${maxLength * 2}px` }}
                  value={
                    limbahPetani.catatanLimbahBatang || "Data belum tersedia"
                  }
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Catatan Limbah Daun</Form.Label>
                <Form.Control
                  readOnly
                  as="textarea"
                  style={{ height: `${maxLength * 2}px` }}
                  value={
                    limbahPetani.catatanLimbahDaun || "Data belum tersedia"
                  }
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Catatan Limbah Akar</Form.Label>
                <Form.Control
                  readOnly
                  as="textarea"
                  style={{ height: `${maxLength * 2}px` }}
                  value={
                    limbahPetani.catatanLimbahAkar || "Data belum tersedia"
                  }
                />
              </Form.Group>
            </Col>
          </Row>
        )}
      </Container>

      <Link to="/traceability" className="back">
        Back To Search
      </Link>
    </div>
  );
};

export default TraceabilityResult;
